// The compact server manifest that coordinates every domain-backed query.
// It contains revision numbers and a hashed authorization-scope fingerprint —
// never response rows, entity ids, user attributes, or other PII.

import { api } from '@/api/client';
import { CADENCE, FRESHNESS, defineQuery } from '@/api/resource';
import type { DataRevisionManifest } from '@/api/types';

export const dataRevisionManifest = defineQuery({
  namespace: 'realtime',
  name: 'dataRevisions.manifest',
  volatile: true,
  keyOf: () => [],
  // A route-intent check writes this exact cache slot before its loader starts.
  // Keeping that just-fetched stamp fresh for the same five-second intent
  // window prevents TopBar's observer from immediately duplicating the cold
  // request; ambient polling and explicit focus/reconnect/manual checks remain.
  freshness: FRESHNESS.intent,
  cadence: CADENCE.ambient,
  // Focus/visibility checks use the coordinator's throttled network-only path
  // so they cannot race a second observer refetch.
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
  request: (_: void, signal) => api.get<DataRevisionManifest>('/data-revisions', { signal }),
});
